import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
    getBlockedUsers,
    unblockChatUser,
} from "../../../reducers/wca/sales-support/sales-support-action";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import Loader from "../../../components/Loader";
import SklbtConfirmation from "../../../components/common/SklbtConfirmation";

const BlockedUsersList = ({ metadataId }) => {
    const dispatch = useDispatch();

    const { blockedUsers } = useSelector((state) => state.wcaEnqChats);

    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState(false);
    const [userPhone, setUserPhone] = useState("");

    const toast = React.useRef(null);

    useEffect(() => {
        fetchBlockedUsers();
    }, []);

    const fetchBlockedUsers = async () => {
        try {
            setLoading(true);

            await dispatch(
                getBlockedUsers({ metadataid: metadataId })
            ).unwrap();
        } catch (err) {
            console.log("Error fetching blocked users", err);

            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Failed to fetch blocked users",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    };



    const handleUnblock = async (phone) => {
        try {
            setLoading(true);
            await dispatch(
                unblockChatUser({
                    metadataid: metadataId,
                    phone,
                })
            ).unwrap();

            setAlert(false);

            toast.current?.show({
                severity: "success",
                summary: "Success",
                detail: "User unblocked successfully",
                life: 3000,
            });

            fetchBlockedUsers();
        } catch (err) {
            console.log("Unblock Error", err);
            setLoading(false);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Failed to unblock user",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    };



    const serialBodyTemplate = (rowData, options) => {
        return options.rowIndex + 1;
    };

    const statusTemplate = () => {
        return <Tag value="Blocked" severity="danger" />;
    };

    const actionTemplate = (rowData) => {
        return (
            <Button
                label="Unblock"
                icon="pi pi-lock-open"
                size="small"
                severity="success"
                onClick={() => {
                    setUserPhone(rowData?.wa_id);
                    setAlert(true);
                }}
            />
        );
    };
    return (
        <div className="card">
            <Toast ref={toast} />
            <SklbtConfirmation
                visible={alert}
                handleConfirm={() => handleUnblock(userPhone)}
                handleReject={() => setAlert(false)}
                message={`Are you sure you want to unblock ${userPhone}?`}
            />
            <Loader visible={loading} />

            <div className="flex justify-content-between align-items-center mb-3">
                <h3 className="m-0">Blocked Customers</h3>
            </div>

            <DataTable
                value={blockedUsers || []}
                loading={loading}
                responsiveLayout="scroll"
                emptyMessage="No blocked users found"
                className="skalebot-table"            >
                <Column
                    header="#"
                    body={serialBodyTemplate}
                    style={{ width: "70px" }}
                />

                <Column
                    field="wa_id"
                    header="WhatsApp Number"
                />

                <Column
                    header="Status"
                    body={statusTemplate}
                />

                <Column
                    header="Action"
                    body={actionTemplate}
                    style={{ width: "180px" }}
                />
            </DataTable>
        </div>
    );
};

export default BlockedUsersList;